export const formatMoney = (
  amount: number,
  fractionDigits: number = 0
): string => {
  if (isNaN(amount)) {
    return null;
  }
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(Number(amount)); // £7,574.00
};
